<h1 mat-dialog-title class="text-center">{{title}}</h1>
<div mat-dialog-content class="text-center">
  <p *ngIf="content !== undefined">{{content}}</p>
  <input type="text" class="form-control" [placeholder]="inputLabel" id="input" required [(ngModel)]="input" name="input">
</div>
<div mat-dialog-actions class="justify-content-center">
  <button mat-button [mat-dialog-close]="'cancel'">Cancel</button>
  <button mat-button [mat-dialog-close]="input" cdkFocusInitial>{{confirmButtonText}}</button>
</div>